package com.tovtalk.utils

import kotlin.time.Clock
import kotlin.time.Instant

actual fun nowInstant(): Instant = Clock.System.now()
